import { ArrowRight, BadgeCheck, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden"
    >
      <div className="absolute -top-32 -right-24 h-[420px] w-[420px] rounded-full bg-brand-sage/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-24 h-[460px] w-[460px] rounded-full bg-brand-terracotta/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-12 md:pt-20 pb-16 md:pb-24 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="animate-fade-up">
          <div
            data-testid="hero-badge"
            className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-brand-sand text-brand-forest text-xs font-medium tracking-wide"
          >
            <BadgeCheck className="h-3.5 w-3.5" />
            Registered NDIS Provider · Australia
          </div>

          <h1
            data-testid="hero-title"
            className="mt-6 font-heading font-bold tracking-tight text-brand-forest text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
          >
            Support that feels like
            <span className="block text-brand-terracotta italic font-medium">family, not paperwork.</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-lg leading-relaxed text-brand-muted max-w-xl"
          >
            Guiding Support Services partners with NDIS participants across Australia
            to deliver warm, reliable, person‑centred care — at home, in the community
            and everywhere in between.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Button
              asChild
              data-testid="hero-cta-primary"
              className="bg-brand-forest hover:bg-brand-forestDark text-brand-bone rounded-full px-7 py-6 text-base font-semibold shadow-sm"
            >
              <a href="#contact">
                Start Your Support Plan
                <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              data-testid="hero-cta-secondary"
              className="rounded-full px-7 py-6 text-base font-semibold border-brand-forest/30 text-brand-forest hover:bg-brand-forest/5"
            >
              <a href="tel:0413918449">
                <Phone className="mr-2 h-4 w-4" />
                Talk to us — 0413 918 449
              </a>
            </Button>
          </div>
        </div>

        <div className="relative animate-fade-up">
          <div className="relative rounded-[2rem] overflow-hidden shadow-xl ring-1 ring-brand-sand">
            <img
              data-testid="hero-image"
              src="https://images.pexels.com/photos/8127569/pexels-photo-8127569.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900"
              alt="Support worker with a participant, showing care and companionship"
              className="w-full h-[460px] md:h-[560px] object-cover"
              loading="eager"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent h-32" />
          </div>

          <div
            data-testid="hero-floating-card"
            className="hidden md:flex absolute -left-6 bottom-8 bg-white rounded-2xl shadow-lg border border-brand-sand px-5 py-4 items-center gap-3 max-w-[260px]"
          >
            <div className="h-10 w-10 rounded-full bg-brand-forest text-brand-bone grid place-items-center">
              <BadgeCheck className="h-5 w-5" />
            </div>
            <div>
              <p className="text-sm font-semibold text-brand-ink leading-tight">NDIS Quality &amp; Safeguards</p>
              <p className="text-xs text-brand-muted">Registered &amp; compliant</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
